import { Action } from '@/_core/fluxstore/types';
import { BoardActivityPanelState, BoardActivityItem } from '../types';
import { useBoardActivityStore } from '../useModule';
import { trimActivities } from '../trimActivities';

const { registerReducer } = useBoardActivityStore();

export class AddRealtimeActivity extends Action<BoardActivityPanelState> {
    public static ACTION_TYPE = 'BoardActivity::AddRealtimeActivity';

    constructor(public activity: BoardActivityItem, public shouldScrollIntoView = false) {
        super(AddRealtimeActivity.ACTION_TYPE);
    }
}

const reducer = (state: BoardActivityPanelState, action: AddRealtimeActivity): void => {
    // Dedup: duplicates do not increment totalCount
    if (state.activities.some(a => a.id === action.activity.id)) {
        return;
    }

    // Push to front
    state.activities.unshift(action.activity);
    state.realtimeAddedActivityIds.unshift(action.activity.id);
    if (action.shouldScrollIntoView) {
        state.latestFollowedActivityId = action.activity.id;
    }

    // Increment totalCount
    state.totalCount++;

    // Cap at 200; an operation cut by the cap is dropped as a whole (AF3)
    if (state.activities.length > 200) {
        state.activities = trimActivities(state.activities, 200);
    }
    if (state.realtimeAddedActivityIds.length > 200) {
        state.realtimeAddedActivityIds.pop();
    }
};

//@ts-ignore
registerReducer(AddRealtimeActivity.ACTION_TYPE, reducer);
